import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/Login'
import Register from '@/Register'
import PrivacyPolicy from '@/PrivacyPolicy'
import TermsOfUse from '@/TermsOfUse'
import ForgotPassword from '@/ForgotPassword'
import PasswordReset from '@/PasswordReset'
import EmailConfirmation from '@/EmailConfirmation'
import Dashboard from '@/Dashboard'
import SentenceSets from '@/pages/SentenceSets'
import Categories from '@/pages/Categories'
import Comments from '@/pages/Comments'
import Stats from '@/pages/Stats'
import News from '@/pages/News'
import SingleNews from '@/pages/SingleNews'
import Profile from '@/pages/Profile'
import MELessons from '@/pages/STBY/MELessons'
import VKLessons from '@/pages/STBY/VKLessons'
import SupportTicket from '@/pages/SupportTicket'
import ConfirmYourMail from '@/ConfirmYourMail'
Vue.use(Router)


const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'login',
            component: Login,
             meta: { requiresGuest: true }
        },
        {
            path: '/register',
            name: 'register',
            component: Register,
            meta: { requiresGuest: true }
        },
        {
            path: '/forgot/password',
            name: 'forgot-password',
            component: ForgotPassword,
            meta: { requiresGuest: true }
        },
        {
            path: '/privacy',
            name: 'privacy',
            component: PrivacyPolicy
        },
        {
            path: '/terms',
            name: 'terms',
            component: TermsOfUse
        },
        {
            path: '/password/reset/:token',
            name: 'password-reset',
            component: PasswordReset,
            meta: { requiresGuest: true }
        },
        {
            path: '/email/confirmation/:token',
            name: 'email-confirmation',
            component: EmailConfirmation,
            // meta: { requiresGuest: true }
        },
        {
            path: '',
            component: Dashboard,
            children: [
                {
                    path: '/stby',
                    component: MELessons,
                },
                {
                    path: '/stby/me',
                    component: MELessons,
                },
                {
                    path: '/stby/vk',
                    component: VKLessons,
                },
                {
                    path: '/dashboard/ticket',
                    component: SupportTicket
                },
            ]
        },
        {
            path: '/confirm-your-mail',
            name: 'confirm-your-mail',
            component: ConfirmYourMail,
            meta: { requiresAuth: true }
        },

        {
            path: '/dashboard',
            component: Dashboard,
            meta: { requiresAuth: true },
            children: [
                {
                  path: 'sentences',
                  component: SentenceSets,
                  meta: { requiresSub: true },
                },
                {
                    path: 'categories',
                    component: Categories,
                    meta: { requiresSub: true },
                },
                {
                  path: 'comments',
                  component: Comments,
                  meta: { requiresSub: true },
                },
                {
                    path: 'stats',
                    component: Stats,
                    meta: { requiresSub: true },
                },
                {
                    path: 'news',
                    component: News,
                    meta: { requiresSub: true },
                },
                {
                    path: 'news/:id',
                    component: SingleNews,
                    meta: { requiresSub: true },
                },
                {
                  path: 'profile',
                  component: Profile
                },
/*                {
                  path: 'ticket',
                  component: SupportTicket
                },*/
                {
                    path: 'privacy',
                    component: PrivacyPolicy
                },
                {
                    path: 'terms',
                    component: TermsOfUse
                },
            ]
        },
        {
            path: '*',
            redirect: '/'
        },
    ]
})

router.beforeEach(function (to, from, next) {
    //console.log(to);
	// prevent access to login & register once signed in...
	if (to.matched.some(record => record.meta.requiresGuest)
		&& window.auth.isAuthenticated())
	{
		next({ path: '/dashboard/comments' });
	}
	if (to.matched.some(record => record.meta.requiresAuth)) {
		// routes with meta.requiresAuth attr require user to be authorized
		// if not, redirect to /auth/signin...
		if (!window.auth.isAuthenticated()) {
			next({
				path: '/',
				query: { redirect: to.fullPath }
			})
		}
	}

    if (to.matched.some(record => record.meta.requiresSub)) {
        if(Vue.prototype.$me.id != -1 && Vue.prototype.$me.subscription.expired){
            next({ path: '/dashboard/profile' });
        }
    }

	next() // make sure to always call next()!
});

export default router





// WEBPACK FOOTER //
// ./src/router/index.js